<script>
    import { createEventDispatcher } from "svelte";
    import { sto_cliente_web, usucon } from "../../store";

    import Contrasenia from "./contraseniauno.svelte";
    import HabilitarCuenta from "./crearcontrasenia.svelte";
    import Consentimiento from "./consentimiento.svelte";

    import Api from "../../api";

    const dispatch = createEventDispatcher();
    const api = new Api("usuarios");

    let opcion = "login";
    let clave = "";
    let password = "";
    let cliente_web_token = "";
    let href = "";

    const hayError = {
        display: "none",
        mensaje: "",
        reset() {
            hayError.display = "none";
            hayError.mensaje = "";
        },
    };

    let tip_doc = "DN";

    const tipDoc = [
        { id: "DN", desc: "Documento Nacional de Identidad" },
        { id: "LE", desc: "Libreta de Enrolamiento" },
        { id: "LC", desc: "Libreta Cívica" },
        { id: "PA", desc: "Pasaporte" },
        { id: "CI", desc: "Cédula de Identidad" },
        { id: "CF", desc: "Cédula de Federal" },
    ];

    async function ingresar() {
        let param = new FormData();
        param.append("accion", "login");
        param.append("clave", tip_doc + " " + clave.trim());
        param.append("password", password);

        let json = await api.procesar(param);

        console.log('JSN:',json);

        if (json.error) {
            hayError.display = "block";
            hayError.mensaje = json.mensaje;
        } else {
            usucon.login({
                usuario: json.usuario,
                rol: json.rol,
                token: json.token,
                tokenUsuario: json.tokenUsuario,
                user_id: json.user_id,
            });

            clave = "";
            password = "";
            tip_doc = "DN";
            cliente_web_token = json.tokenUsuario;

            console.log('TOKEN:', cliente_web_token);
            
            if ($sto_cliente_web.client_id && $sto_cliente_web.redirect_url) {
                let esvalido = await cliente_web_valido();
                if (esvalido) {
                    opcion = "consentimiento";
                } else {
                    dispatch("validado");
                }
            } else {
                dispatch("validado");
            }
        }
    }

    async function cliente_web_valido() {
        let param = new FormData();
        param.append("accion", "validar_client_id");
        param.append("client_id", $sto_cliente_web.client_id);

        let res = await fetch("api/cliente_web.php", {
            method: "POST",
            body: param,
            cache: "no-cache",
        });

        let jsn = await res.json();

        if (res.ok) {
            return !jsn.error;
        } else {
            return false;
        }
    }
</script>

{#if opcion == "login"}
    <div class="w3-content" style="max-width:400px">
        <div class="w3-padding w3-border w3-round">
            <h4>Iniciar sesión.</h4>
            <div on:click={() => hayError.reset()}>
                <div class="w3-section">
                    <label for="clave">Tipo de Documento:</label>
                    <select class="w3-input w3-light-grey" bind:value={tip_doc}>
                        {#each tipDoc as tido}
                            <option value={tido.id}>{tido.desc}</option>
                        {/each}
                    </select>
                </div>
                <div class="w3-section">
                    <label for="clave">Número de Documento:</label>
                    <input
                        name="clave"
                        type="text"
                        class="w3-input w3-light-grey"
                        bind:value={clave}
                    />
                </div>
                <div class="w3-section">
                    <label for="clave">Contraseña:</label>
                    <input
                        name="contrasenia"
                        type="password"
                        class="w3-input w3-light-grey"
                        bind:value={password}
                    />
                </div>

                <div class="w3-section">
                    <a
                        href="/"
                        on:click|preventDefault={() =>
                            (opcion = "habilitar_cuenta")}
                        >Habilitar mi cuenta.</a
                    >
                </div>
                <div class="w3-section">
                    <a
                        href="/"
                        on:click|preventDefault={() => (opcion = "contrasenia")}
                        >Olvidaste tu contraseña o deseas crear una nueva, haz
                        click aquí.</a
                    >
                </div>
                <div class="w3-section">
                    <button
                        class="w3-btn w3-blue w3-round w3-block"
                        on:click={ingresar}>Ingresar</button
                    >
                </div>
            </div>
            <div class="w3-section" style="display:{hayError.display}">
                <div class="w3-padding  w3-round w3-yellow w3-text-red">
                    {@html hayError.mensaje}
                </div>
                <br />
                <div class="w3-padding w3-border w3-round">
                    Si tenés inconvenientes para <b
                        >Crear o modificar tu contraseña</b
                    >, envianos un mail a:
                    <a
                        href="mailto:graduados@ucc.edu.ar"
                        class="w3-text-blue"
                        target="_blank">graduados@ucc.edu.ar</a
                    >
                </div>
            </div>
        </div>
    </div>
{/if}

{#if opcion == "contrasenia"}
    <Contrasenia
        on:inicio={() => (opcion = "login")}
        on:cancelar={() => (opcion = "login")}
    />
{/if}

{#if opcion == "habilitar_cuenta"}
    <HabilitarCuenta on:cancelar={() => (opcion = "login")} />
{/if}

{#if opcion == "consentimiento"}
    <Consentimiento
        token={cliente_web_token}
        on:conceder={() => {
            opcion = "login";

            sto_cliente_web.actualizar({
                client_id: "",
                redirect_url: "",
                state: "",
                response_type: "",
            });
        }}
    />
{/if}
